import Vue from 'vue'
import UIkit from 'uikit'
import Icons from 'uikit/dist/js/uikit-icons'
import App from './App.vue'
import router from './routes'
import store from './store'
import localforage from 'localforage'

localforage.config({
  driver: localforage.LOCALSTORAGE,
  storeName: 'neqst'
})

Vue.config.productionTip = false
Vue.config.ignoredElements = ['trix-editor']

UIkit.use(Icons)
Vue.prototype.$uikit = UIkit

const utils = {
  'pick-image': Vue.extend(require('@/components/finder/PickImage.vue').default)
  // 'video-picker': Vue.extend(require('./video-picker.vue')),
  // 'link-picker': Vue.extend(require('./link-picker.vue'))
}

const vm = new Vue({
  router,
  store,
  utils,
  render: h => h(App)
}).$mount('#app')

window.vm = vm
